import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import WorkflowConverter from 'app/admin/workflow/component/WorkflowConverter';
import nBossConnection from 'modules/base/service/nBossConnection';
import WorkflowModelEditDto from '../dto/WorkflowModelEditDto';

class WorkflowModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'workflowModelEditControl';
	}

	/**
	 * @param {string} driverName
	 * @return {Promise<WorkflowModelEditDto>}
	 */
	create(driverName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/create`, { driverName })
				.then(response => resolve(new WorkflowModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<WorkflowModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new WorkflowModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {WorkflowModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		dto.export = dto.json ? WorkflowConverter(dto.name, dto.json) : null;
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {WorkflowModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		dto.export = dto.json ? WorkflowConverter(dto.name, dto.json) : null;
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} name
	 * @param {string} version
	 * @param {Object} state
	 * @return {Promise<Object>}
	 */
	debug(name, version, state) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/debug`, { name, version, state })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new WorkflowModelEditService();
